module.exports = __webpack_public_path__ + "img/btn_price_tag@3x.bbc847e6.png";